import React from 'react';
import BlazeLink from '../BlazeLink';
import LazyImage from '../LazyImage';
const SearchContentItems = ({
  results = [],
  onClick
}) => results.map(item => {
  if (!item || !item.url) return null;
  const {
    id,
    name,
    image,
    url
  } = item;
  return /*#__PURE__*/React.createElement(BlazeLink, {
    href: url,
    onClick: onClick,
    key: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "search-content--results__wrapper"
  }, (image === null || image === void 0 ? void 0 : image.url) ? /*#__PURE__*/React.createElement(LazyImage, {
    src: image.url,
    alt: name,
    className: "search-content--results__image",
    sizeKey: "search-result"
  }) : null, /*#__PURE__*/React.createElement("span", {
    className: "search-content--results__title"
  }, name)));
});
export default SearchContentItems;
//# sourceMappingURL=SearchContentItems.js.map